
























import Vue from 'vue'
import { mapState } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import { providerLogo } from '@/utils/helpers'

@Component({
  props: {
    provider: { type: String, required: true },
    availableProviders: { type: Array, required: false }
  },
  computed: {
    ...mapState({
      isMobile: (state: any): object => state.context.isMobile,
      isLoading: (state: any): object => state.context.isLoading
    })
  }
})
export default class ProviderSelector extends Vue {
  isMobile: boolean
  isLoading: boolean
  showChangeProvider: boolean = false
  $refs!: {
    providerSelect: HTMLSelectElement,
    providerSelectedLogo: HTMLImageElement,
  }

  @Action('setIdentifyProviderId', { namespace: 'context' }) setIdentifyProviderId: any

  get getProviderLogo () {
    return providerLogo(this.$props.provider)
  }

  async toggleProviderIconAndSelect () {
    await this.$nextTick()
    this.showChangeProvider = !this.showChangeProvider
  }

  handleProviderClick () {
    this.toggleProviderIconAndSelect()
  }

  async handleProviderSelect (e) {
    await this.$nextTick()
    // We need to update the config value since that's used as key to find the providerObject in the onChange-handler in TopContainer
    this.setIdentifyProviderId(e.target.value)

    this.$emit('identify-provider-changed')
    this.toggleProviderIconAndSelect()

    await this.$nextTick()
    setTimeout(() => {
      this.$refs.providerSelectedLogo.style.visibility = 'visible'
    }, 250)
  }
}
